// src/components/admin/Pagination.jsx
import React from 'react';

const Pagination = ({ 
  currentPage = 1, 
  totalPages = 1, 
  totalItems = 0, 
  itemsPerPage = 10, 
  onPageChange = () => {},
  isLoading = false
}) => {
  // Calculate the range of items being displayed
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages && newPage !== currentPage && !isLoading) {
      onPageChange(newPage);
    }
  };

  // Don't render pagination if there's only one page
  if (totalPages <= 1) {
    return (
      <div className="px-4 py-2 bg-gray-50 border-t border-gray-200 rounded-b-lg">
        <p className="text-xs text-gray-600">
          Affichage de {startItem} à {endItem} sur {totalItems} résultat(s)
        </p>
      </div>
    );
  }

  return (
    <div className="px-4 py-2 flex items-center justify-between border-t border-gray-200">
      <div className="flex-1 flex justify-between items-center">
        <p className="text-xs text-gray-700">
          Affichage de{' '}
          <span className="font-medium">{startItem}</span>
          {' '}à{' '}
          <span className="font-medium">{endItem}</span>
          {' '}sur{' '}
          <span className="font-medium">{totalItems}</span>
          {' '}résultats
        </p>
        <div className="flex space-x-1">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1 || isLoading}
            className="px-2.5 py-1.5 text-xs border border-gray-300 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:ring-offset-1"
          >
            Précédent
          </button>
          
          {/* Page numbers */}
          <div className="flex space-x-1">
            {/* First page */}
            {currentPage > 2 && (
              <>
                <button
                  onClick={() => handlePageChange(1)}
                  className="px-2 py-1.5 text-xs border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500"
                >
                  1
                </button>
                {currentPage > 3 && (
                  <span className="px-2 py-1.5 text-xs text-gray-500">...</span>
                )}
              </>
            )}
            
            {/* Previous page */}
            {currentPage > 1 && (
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                className="px-2 py-1.5 text-xs border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500"
              >
                {currentPage - 1}
              </button>
            )}
            
            {/* Current page */}
            <button
              className="px-2 py-1.5 text-xs border border-blue-500 bg-blue-50 text-blue-600 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
              disabled
            >
              {currentPage}
            </button>
            
            {/* Next page */}
            {currentPage < totalPages && (
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                className="px-2 py-1.5 text-xs border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500"
              >
                {currentPage + 1}
              </button>
            )}
            
            {/* Last page */}
            {currentPage < totalPages - 1 && (
              <>
                {currentPage < totalPages - 2 && (
                  <span className="px-2 py-1.5 text-xs text-gray-500">...</span>
                )}
                <button
                  onClick={() => handlePageChange(totalPages)}
                  className="px-2 py-1.5 text-xs border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500"
                >
                  {totalPages}
                </button>
              </>
            )}
          </div>
          
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages || isLoading}
            className="px-2.5 py-1.5 text-xs border border-gray-300 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:ring-offset-1"
          >
            Suivant
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;